export const WALLET_UPDATE_EVENT = '/wallet/userWalletBalance'
export const MESH_TRANSFER_STATUS_EVENT = '/wallet/meshTransferStatus'
